<template>
    <div
        v-if="user.profile_layout === 'hero'"
        class="profile-section text-center hero-profile"
    >
        <ProfileAvatar :user="user" />


        <div v-if="user.profile_title_status == 1" class="pt-4">
            <h1
                class="hero-username"
                :style="titleStyle"
            >
                {{ user.profile_title ?? "@" + user.username }}
            </h1>
        </div>
        <div v-if="user.profile_bio_status == 1" class="pt-1">
            <h2 class="hero-bio" :style="bioStyle">{{ user.profile_bio }}</h2>
        </div>
    </div>

    <div v-else class="profile-section text-center classic-layout">
        <ProfileAvatar :user="user" />


        <div v-if="user.profile_title_status == 1" class="text-center pt-3 mb-1">
            <h1 class="username" :style="titleStyle">
                {{ user.profile_title ?? user.username }}
            </h1>
        </div>

        <div
            v-if="user.profile_bio_status == 1 && user.profile_bio?.trim()"
            class="text-center p-1"
        >
            <h2 class="user-bio" :style="bioStyle">{{ user.profile_bio }}</h2>
        </div>
    </div>
</template>

<script setup>
import ProfileAvatar from "@/Components/UserProfile/ProfileAvatar.vue";
import { resolveProfileFontWeight } from "@/utils/profileAppearance";
import { computed } from "vue";

const props = defineProps({
    user: { type: Object, required: true },
    appearance: { type: Object, required: true },
});

const fontWeight = computed(() => resolveProfileFontWeight(props.appearance));

const titleStyle = computed(() => ({
    color: props.appearance?.fonts_color,
    fontFamily: props.appearance?.fonts,
    fontWeight: fontWeight.value,
    marginTop:
        props.user.profile_layout === "hero" && props.user.profile_image_status != 1
            ? "57px"
            : undefined,
}));

const bioStyle = computed(() => ({
    color: props.appearance?.fonts_color,
    fontFamily: props.appearance?.fonts,
    fontWeight: fontWeight.value,
}));
</script>

<style scoped>
.classic-layout {
    margin-top: 53px;
}

.username {
    margin: 0;
    font-size: 1.25rem;
    line-height: 1.4;
}

.user-bio {
    margin: 0.25rem 0 1rem;
    font-size: 1rem;
    line-height: 1.6;
}

.hero-profile {
    margin-top: 0;
}

.hero-username {
    margin: 0;
    padding: 5px;
    font-size: 1.6rem;
}

.hero-bio {
    margin: 0.25rem 0 0.75rem;
    padding: 5px;
    font-size: 1rem;
    opacity: 0.95;
}

@media (min-width: 640px) {
    .hero-username {
        font-size: 1.8rem;
    }
}
</style>
